import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IFilterParams, IInvoice, IInvoicesList } from '../../interfaces';

export const useInvoice = (): IInvoice => {
    return useContext(MobXProviderContext).RootStore.invoicesStore.item;
};
export const useInvoicesList = (): IInvoicesList => {
    return useContext(MobXProviderContext).RootStore.invoicesStore.list;
};

export const useInvoicesFilterParams = (): IFilterParams => {
    return useContext(MobXProviderContext).RootStore.invoicesStore.filterParams;
};
